import React from 'react';

import { TeamAvatarGroupProps } from './types';
import { HorizontalOverlappingAvatars } from './HorizontalOverlappingAvatars';
import { transformTeamToAvatar } from './transformTeamToAvatar';

/**
 * Render a list of `teams` as an AvatarGroup.
 *
 * Avatars will be rendered next to and slightly overlapping each other.
 * When the list has more than `truncateAfter` elements, the list will be truncated,
 * and a (+N) - placeholder is shown that `onClick` will show a
 * Menu listing containing the remaining avatars.
 *
 * If `navigateTo` is set via `BaukastenContext`,
 * clicking on an Avatar will navigate to that team's page.
 */
const TeamAvatarGroup = ({ teams, truncateAfter }: TeamAvatarGroupProps) => {
  const teamAvatars = teams.map(transformTeamToAvatar);

  return (
    <HorizontalOverlappingAvatars
      avatars={teamAvatars}
      truncateAfter={truncateAfter}
      getNavigationPath={avatar => `/goals/overview/teams/${avatar.id}`}
    />
  );
};

export { TeamAvatarGroup };
